var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { display: "contents" } },
    [
      _vm.step === "search"
        ? _c("v-icon", { attrs: { large: "", left: "" } }, [
            _vm._v("\n\t\taccount_tree\n\t")
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.step === "unitary" || _vm.step === "batch"
        ? _c(
            "v-btn",
            {
              staticClass: "mr-3",
              attrs: { icon: "", large: "" },
              on: {
                click: function($event) {
                  return _vm.$emit("search")
                }
              }
            },
            [_c("v-icon", { attrs: { large: "" } }, [_vm._v("arrow_back")])],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.step === "search"
        ? _c("h4", { staticClass: "headline" }, [_vm._v("Choix du workflow")])
        : _vm._e(),
      _vm._v(" "),
      _vm.step === "unitary" || _vm.step === "batch"
        ? _c(
            "h4",
            { staticClass: "headline" },
            [
              _vm._v("\n\t\t" + _vm._s(_vm.jd.label) + "\n\t\t"),
              _vm.is_admin
                ? _c(
                    "v-btn",
                    {
                      staticClass: "ml-0",
                      attrs: {
                        small: "",
                        icon: "",
                        target: "_blank",
                        href: _vm.maestro_url + "jobs/versions/" + _vm.jd.id
                      }
                    },
                    [_c("v-icon", [_vm._v("music_note")])],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "caption",
                  staticStyle: { "line-height": "16px" }
                },
                [_vm._v("\n\t\t\t" + _vm._s(_vm.jd.description) + "\n\t\t")]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "caption",
                  staticStyle: { "line-height": "16px" }
                },
                [
                  _vm._v(
                    "\n\t\t\t" + _vm._s(_vm.jd.version_description) + "\n\t\t"
                  )
                ]
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c("v-spacer"),
      _vm._v(" "),
      _vm.step === "search"
        ? _c(
            "v-btn",
            {
              staticClass: "ma-0 text-none",
              staticStyle: { border: "1px solid" },
              attrs: {
                small: "",
                depressed: "",
                color: "background darken-1 orange--text text--accent-3"
              },
              on: {
                click: function($event) {
                  return _vm.$emit("open-old-launcher")
                }
              }
            },
            [
              _c("v-icon", { staticClass: "mr-1" }, [_vm._v("arrow_back")]),
              _vm._v("\n\t\tAncien launcher (déprécié)\n\t")
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "v-btn",
        {
          attrs: { icon: "", large: "" },
          on: {
            click: function($event) {
              return _vm.$emit("close")
            }
          }
        },
        [_c("v-icon", { attrs: { large: "" } }, [_vm._v("close")])],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3d0226ec", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3d0226ec","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./build/scramble/app-loader.js!./src/pages/maestro/launcher/launcher_v2_header.vue
// module id = null
// module chunks = 